import React from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import AssetDetailsForTicketing from "../AssetDetails";
import { TableType } from "../../../../customer/companies/queries/types";
import { StateTypes } from "../../Maps";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<StateTypes>>;
  showRaiseTicket: boolean;
  assetType: TableType;
  isItemsView?: boolean;
}
const JunctionLevelTicketing = ({
  setModalFlag,
  assetType,
  isItemsView,
}: Props) => {
  return (
    <div className="ticketing">
      <div className="ticketing__title">
        <Title>Ticketing</Title>

        <img
          src={Close}
          alt=""
          onClick={() =>
            setModalFlag({
              flag: false,
              itemId: 0,
              tableLevel: TableType.COMPANY,
            })
          }
        />
      </div>
      {/* {showRaiseTicket ? (
        <div className="ticketing__tabs">
          <Tabs value={value} onChange={handleChange}>
            <Tab label={`${itemLabel} Wise`} value={0} {...a11yProps(0)} />
          </Tabs>
        </div>
      ) : null} */}
      <div className="ticketing__tab-panel">
        {/* {showRaiseTicket ? (
          <TabPanel value={value} index={0}> */}
        <AssetDetailsForTicketing
          setModalFlag={setModalFlag}
          assetType={assetType}
          isItemsView={isItemsView}
        />
        {/* </TabPanel>
        ) : (
          <History />
        )} */}
        {/* <TabPanel value={value} index={1}>
          <History />
        </TabPanel> */}
      </div>
    </div>
  );
};

export default JunctionLevelTicketing;
